import { inject, Injectable } from '@angular/core';
import { GeoEntityApiService } from './geo-entity-api.service';
import { LocationService } from '@client-monorepo/common/location-management';
import { map, Observable, of, switchMap } from 'rxjs';
import { GetGeoEntitiesResponse } from '../models/get-geo-entities.response';
import { GeoEntity } from '../models/geo-entity';

@Injectable({
  providedIn: 'root',
})
export class GeoEntityService {
  geoEntityApiService = inject(GeoEntityApiService);
  locationService = inject(LocationService);
  geoEntities?: GeoEntity[];

  getGeoEntities(): Observable<GetGeoEntitiesResponse> {
    if (this.geoEntities) {
      return of({ geoEntityLinks: this.geoEntities });
    }
    return this.locationService.getLocation().pipe(
      switchMap((coordination) => {
        if (coordination) {
          return this.geoEntityApiService.getGeoEntities(coordination.latitude, coordination.longitude).pipe(
            map((res) => {
              this.geoEntities = res.geoEntityLinks;
              return res;
            }),
          );
        }
        return of({ geoEntityLinks: [] });
      }),
    );
  }

  getHashMapOfClassName(classNames: string[]): Observable<{ [key: string]: { [key: string]: boolean } }> {
    return this.getGeoEntities().pipe(
      map((res) => {
        const geoEntitiesHashMap: { [key: string]: { [key: string]: boolean } } = {};
        classNames.forEach((className) => {
          geoEntitiesHashMap[className] = {};
        });
        res.geoEntityLinks.forEach((item) => {
          classNames.forEach((className) => {
            if (item.className === className) {
              geoEntitiesHashMap[className][item.objectId] = true;
            }
          });
        });
        return geoEntitiesHashMap;
      }),
    );
  }
}
